var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 72,
    viewBox: "0 0 18 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4098_40474)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0.599998C18 0.399998 18 0.2 18 0L4.19999 1.20643e-06C1.99999 1.39876e-06 0.199995 1.8 0.199995 4L0.2 68C0.200001 70.2 2 72 4.2 72L18 72L18 0.599998Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7099 35.9994L6.4099 36.6994L6.0099 35.9994L6.4099 35.2994L7.7099 35.9994ZM12.1099 41.2994C12.5099 41.9994 12.2099 42.8994 11.5099 43.2994C10.8099 43.6994 9.8099 43.3994 9.4099 42.6994L12.1099 41.2994ZM9.4099 29.2994C9.8099 28.5994 10.8099 28.2994 11.5099 28.6994C12.2099 29.0994 12.5099 29.9994 12.1099 30.6994L9.4099 29.2994ZM9.0099 35.2994L12.1099 41.2994L9.4099 42.6994L5.9099 35.9994L9.0099 35.2994ZM12.1099 30.6994L9.3099 36.0994L9.0099 36.6994L5.9099 35.9994L9.4099 29.2994L12.1099 30.6994Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4098_40474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 72,
    fill: "white",
    transform: "translate(18 72) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.0560f24c1203e1260e7f4ddc47426570.svg";
export { ForwardRef as ReactComponent };